import stickybits from "stickybits";
import imagesloaded from "imagesloaded";
import { TimelineMax } from "gsap";
import { triggerEvent, offset, hasClass } from "../util/utils";
import _ from "lodash";

let sticky;
let tlSearchOpen, tlSearchClose;
/**
 * INIT
 * ----
 * This function initialize every element of the main header
 **/
export function init() {

  imagesloaded("#main-header", function() {
    // Make main header sticky
    // https://www.npmjs.com/package/stickybits
    sticky = stickybits("#main-header", {
      useStickyClasses: true
    });
  });

  // setup hamburger behaviour
  setupHamburger();
  window.addEventListener("resize", _.debounce(clearNavResize, 100), false);

  // setup search behaviour
  setupSearch();

  // setup scroll header
  setupScrollHeader();
  window.addEventListener("scroll", _.debounce(setupScrollHeader, 1), false);
}

/**
 * RESIZE PRIMARY NAVIGATION BAR
 **/
// function resizePrimaryNavBar() {
//   const mainHeader = document.getElementById("main-header");
//   const container = document.querySelector(".main-header--container");
//   const nav = document.querySelector(".nav-primary");
//   // Get margin bottom
//   const marginBottom = window.innerHeight - container.offsetHeight - mainHeader.offsetTop;
//   nav.style.marginBottom = `${marginBottom}px`;
// }

/**
 * SETUP HAMBURGER BEHAVIOUR
 **/
function setupHamburger() {
  const tlHamburgerOpen = new TimelineMax({
    paused: true,
    onComplete: _ => {}
  });
  const tlHamburgerClose = new TimelineMax({
    paused: true,
    onComplete: _ => {
      TweenLite.set(
        [
          ".nav-primary",
          ".nav-primary > ul",
          ".hamburger--inside",
          ".hamburger--outside"
        ],
        { clearProps: "all" }
      );
    }
  });

  // open
  tlHamburgerOpen
    .add("start")
    .set(".nav-primary", { className: "+=opened" }, "start+=0.2")
    .to(
      ".hamburger--outside",
      0.6,
      { opacity: 0, xPercent: -100, ease: Power4.easeInOut },
      "start"
    )
    .to(".nav-primary", 0.6, { x: 0, ease: Power4.easeInOut }, "start")
    .to(
      ".nav-primary > ul",
      1,
      { x: 0, opacity: 1, ease: Power4.easeInOut },
      "start+=0.2"
    )
    .to(
      ".hamburger--inside",
      0.6,
      { x: 0, opacity: 1, ease: Power4.easeInOut },
      "start+=0.6"
    );

  // close
  tlHamburgerClose
    .add("start")
    .set(".nav-primary", { className: "-=opened" }, "start+=0.2")
    .to(
      ".nav-primary",
      0.5,
      {
        x: -document.querySelector(".nav-primary").offsetWidth,
        ease: Power4.easeInOut
      },
      "start"
    )
    .to(
      ".nav-primary > ul",
      0.5,
      { xPercent: 0, opacity: 0, ease: Power4.easeInOut },
      "start"
    )
    .to(
      ".hamburger--inside",
      0.5,
      { xPercent: 0, opacity: 0, ease: Power4.easeInOut },
      "start"
    )
    .to(
      ".hamburger--outside",
      0.5,
      { xPercent: 0, opacity: 1, ease: Power4.easeInOut },
      "start+=0.3"
    );

  document
    .querySelector(".hamburger--outside")
    .addEventListener("click", () => {
      tlHamburgerOpen.restart();

      // close search if menu is opened when search is opened
      if (
        document.querySelector(".search--wrapper").classList.contains("opened")
      ) {
        triggerEvent(document.querySelector(".search--close"), "click");
      }
    });
  document.querySelector(".hamburger--inside").addEventListener("click", () => {
    tlHamburgerClose.restart();
  });

  document.querySelector("#main-content").addEventListener("click", () => {
    if ($(".nav-primary").hasClass("opened")) {
      triggerEvent(document.querySelector(".hamburger--inside"), "click");
    }
  });

  document.addEventListener("keyup", e => {
    if (e.keyCode === 27) {
      if ($(".nav-primary").hasClass("opened")) {
        triggerEvent(document.querySelector(".hamburger--inside"), "click");
      }
    }
  });
}

function clearNavResize() {
  TweenLite.set(
    [
      ".nav-primary",
      ".nav-primary > ul",
      ".hamburger--inside",
      ".hamburger--outside"
    ],
    { clearProps: "all" }
  );
}

function setupSearch() {
  tlSearchOpen = new TimelineMax({
    paused: true,
    onStart: searchResize,
    onComplete: _ => {
      $(".search--input input").focus();

    }
  });
  tlSearchClose = new TimelineMax({
    paused: true,
    onComplete: _ => {
      TweenLite.set([".search--wrapper"], { clearProps: "all" });
      searchResize();
    }
  });

  // open
  tlSearchOpen
    .add("start")
    .set(".search--wrapper", { className: "+=opened" }, "start+=0.2")
    .set(".search--close", {position: 'relative'})
    .set(".search--open", {position: 'absolute'})
    .to(
      ".search--wrapper",
      0.6,
      { opacity: 1, y: 0, "pointer-events": "auto", ease: Power4.easeInOut },
      "start"
    )
    .to(".search--open", 0.15, {autoAlpha: 0, zIndex: 1}, "start")
    .to(".search--close", 0.5, {autoAlpha: 1, zIndex: 2}, "start")

  // open
  tlSearchClose
    .add("start")
    .set(".search--wrapper", { className: "-=opened" }, "start+=0.2")
    .set(".search--open", {position: 'relative'})
    .set(".search--close", {position: 'absolute'})
    .to(".search--close", 1, {autoAlpha: 0,zIndex: 1}, "start")
    .to(".search--open", 0.5, {autoAlpha: 1, zIndex: 2}, "start")
    .to(
      ".search--wrapper",
      0.6,
      { opacity: 0, y: -20, "pointer-events": "none", ease: Power4.easeInOut },
      "start"
    )


  document.querySelector(".search--open").addEventListener("click", () => {
    if (
      document.querySelector(".search--wrapper").classList.contains("opened")
    ) {
      tlSearchClose.restart();
    } else {
      tlSearchOpen.restart();
    }

    // close search if menu is opened when search is opened
    if (document.querySelector(".nav-primary").classList.contains("opened")) {
      triggerEvent(document.querySelector(".hamburger--inside"), "click");
    }
  });
  document.querySelector(".search--close").addEventListener("click", () => {
    tlSearchClose.restart();
  });
  document.addEventListener("keyup", e => {
    if (e.keyCode === 27) {
      if ($(".search--wrapper").hasClass("opened")) {
        tlSearchClose.restart();
      }
    }
  });

  searchResize();
  window.addEventListener("resize", _.debounce(searchResize, 100), false);
}
// fix headerBar.offsetHeight //
function searchResize() {
  const mainContent = document.getElementById('main-content');
  const mainHeader = document.getElementById('main-header');
  const searchWrapper = document.querySelector('.search--wrapper');
  const htmlElement = document.querySelector('html');
  const headerBar = document.querySelector(".header-bar");

  if (hasClass(htmlElement, 'scrolled') || mainHeader.position == 'sticky') {
    // trashold is workaround for unwanted pixel (could be solved differently)
    const trashold = 1;
    searchWrapper.style.top = `${headerBar.offsetHeight - trashold}px`;
  } else {
    const mainContentOffset = offset(mainContent);
    const mainContentStyles = window.getComputedStyle(mainContent);
    const mainContentMarginTop = parseInt(mainContentStyles.getPropertyValue('margin-top'), 10);
    searchWrapper.style.top = `${mainContentOffset.top - mainContentMarginTop + window.scrollY}px`;
  }
}

// function setupScrollHeader() {
//   //if(window.pageYOffset > document.querySelector('.main-header--container').offsetHeight) {
//   if(window.pageYOffset > 30) {
//     TweenLite.set('html', { className: '+=scrolled' })
//   } else {
//     TweenLite.set('html', { className: '-=scrolled' })
//   }
// }

function setupScrollHeader() {
  let hasTopBanner = false;
  let topOffset = 30;

  // Close search bar if you scroll

  tlSearchClose.restart();

  if ($(".header--indicator").offset().top > 1) {
    hasTopBanner = true;
    topOffset = 50;
  }

  if (window.pageYOffset >= $(".header--indicator").offset().top + topOffset) {
    $("html").addClass("scrolled");
  } else {
    $("html").removeClass("scrolled");
  }

  if (hasTopBanner) {
    $("html").addClass("has-topbanner");
  } else {
    $("html").removeClass("has-topbanner");
  }
}



// WEBPACK FOOTER //
// ./scripts/components/MainHeader.js